import { cloneDeep } from 'lodash'
import { NlpModel, NlpModelId, NlpSettings } from '@feedyou-ai/feedbot-schema'

const NLP_COUNTER_SEPARATOR = '-'

export function adjustModelIdsToNlpModelIdFormat(
  nlpSettings: NlpSettings,
  allNlpModels: NlpModel[] = []
): NlpSettings {
  const models = nlpSettings.models?.reduce((output, model) => {
    const existingModels = [...allNlpModels, ...output]
    output.push({ ...model, id: adjustIdToNlpModelIdFormat(model.id, existingModels) })
    return output
  }, [] as NlpModel[])

  return { ...nlpSettings, models }
}

export function adjustModelIdToNlpModelIdFormat(
  modelId: NlpModelId,
  models: NlpModel[]
): NlpModelId {
  let newModelId = modelId
  do {
    newModelId = adjustIdToNlpModelIdFormat(newModelId, models)
  } while (models.find(({ id }) => id === newModelId))
  return newModelId
}

function adjustIdToNlpModelIdFormat(modelId: string, models: NlpModel[]): string {
  if (!existsModel(modelId, models)) {
    return modelId
  }

  const separator = NLP_COUNTER_SEPARATOR
  const lastFoundModel = getLastFoundModelWithCounter(separator, modelId, models)
  if (!lastFoundModel) {
    return `${modelId}${separator}${2}`
  }

  const splits = lastFoundModel.id.split(`${separator}`)
  const nextCounter = Number(splits.pop()) + 1
  const baseModelId = splits.join(separator)

  return `${baseModelId}${separator}${nextCounter}`
}

function existsModel(modelId: string, models: NlpModel[]): boolean {
  return models.some(model => model.id === modelId)
}

function getLastFoundModelWithCounter(
  separator: string,
  modelId: string,
  models: NlpModel[]
): NlpModel | undefined {
  return cloneDeep(models)
    .filter(model => isModelIdEndingWithCounter(model, modelId, separator))
    .sort((modelA, modelB) => getSortResult(modelA, modelB, separator))
    .pop()
}

function isModelIdEndingWithCounter(model: NlpModel, modelId: string, separator: string): boolean {
  if (!model.id.includes(`${modelId}${separator}`)) {
    return false
  }

  return !!model.id.match(`^(.*${modelId}${separator})(\\d+)$`)
}

function getSortResult(modelA: NlpModel, modelB: NlpModel, separator: string): number {
  const counterA = Number(modelA.id.split(separator).pop())
  const counterB = Number(modelB.id.split(separator).pop())

  return counterA > counterB ? 1 : -1
}
